module.exports = __webpack_public_path__ + "img/08_choice 1.a5aca439.png";